import style from './outsourcing-to-dedicated-teams.module.scss';
import template from '@components/services/services.module.scss';
import Image from 'next/image';

interface IOutsourcingToDedicatedTeamsSection {
    imageSrc: string;
    title: string;
    text: string[];
    list: string[];
}

const OutsourcingToDedicatedTeams = ({ imageSrc, title, text, list }: IOutsourcingToDedicatedTeamsSection) => {
    return (
        <section className={`${style.section}`}>
            <div className={`${template.container} ${template.container_large} ${style.block} ${template.flex} ${template.flex_justify_content_space_between}`}>
                <div className={`${template.image} ${template.image_medium} ${style.image}`}>
                    <Image src={imageSrc} alt={title} layout={'fill'} />
                </div>
                <div className={`${style.textblock}`}>
                    <div className={`${template.title} ${template.title_large} ${template.text_align_l} ${template.mb20}`}>
                        <h2 className={`${template.title_large}`}>
                            {title}
                        </h2>
                    </div>
                    <div className={`${style.textblock__content}`}>
                        {text.map((item: string, index: number) => {
                            return (
                                <div key={index}
                                     className={`${template.text} ${template.text_small} ${template.text_color_main} ${template.text_align_l} ${style.textblock__content__text} ${template.mb16} ${template.fw400}`}
                                     dangerouslySetInnerHTML={{__html: item}}>
                                </div>
                            )
                        })}
                    </div>
                    <ul className={`${style.list}`}>
                        {
                            list.map((item: string, index: number) => {
                                return (
                                    <li key={index}>
                                        {item}
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
            </div>
        </section>
    )
}

export default OutsourcingToDedicatedTeams;
